import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './InfoScreen.css';
import contentData from '../data/infoScreenContent.json';
import { logEvent } from '../utils/Logger';
import xIcon from '../images/x_icon.svg';

interface InfoScreenProps {
  onClose: () => void;
}

const InfoScreen: React.FC<InfoScreenProps> = ({ onClose }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isShowingFoundations, setIsShowingFoundations] = useState(true);
  const [content, setContent] = useState<any>(null);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setContent(contentData);
  }, []);

  const handleClose = () => {
    logEvent('info_screen_exit', 'User closed the info screen', location.pathname);
    onClose();
  };

  const handleNavigation = () => {
    const action = isShowingFoundations ? 'next' : 'previous';
    logEvent(`info_screen_${action}`, `User clicked ${action} button`, location.pathname);
    setIsShowingFoundations(!isShowingFoundations);
    if (contentRef.current) {
      contentRef.current.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  if (!content) return null;

  return (
    <div className="info-screen">
      <div className="info-header">
        {/* <button className="nav-button" onClick={handleNavigation}>
          {isShowingFoundations ? 'Next' : 'Previous'}
        </button> */}
        <h2>{content.moralFoundations.title}</h2>
        <button className="close-button" onClick={handleClose}>
          <img src={xIcon} alt="Close" width="20" height="20" />
        </button>
      </div>
      <div className="info-content-wrapper" ref={contentRef}>
        <div className="info-content">
          {!isShowingFoundations ? (
            <div className="writing-advice">
              <h2>{content.writingAdvice.title}</h2>
              {content.writingAdvice.foundations.map((foundation: any, index: number) => (
                <div key={index} className="foundation">
                  <h2>{foundation.title}</h2>
                  <p>{foundation.description}</p>
                </div>
              ))}
            </div>
          ) : (
            <div className="moral-foundations">
              {content.moralFoundations.foundations.map((foundation: any, index: number) => (
                <div key={index} className={`foundation ${foundation.class}`}>
                  <h2 className={foundation.class}>{foundation.title}</h2>
                  <p>{foundation.description}</p>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default InfoScreen;